import { render, staticRenderFns } from "./inventoryIconWhite.vue?vue&type=template&id=207860c2&scoped=true&"
import script from "./inventoryIconWhite.vue?vue&type=script&lang=js&"
export * from "./inventoryIconWhite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207860c2",
  null
  
)

export default component.exports